import dynamic from "next/dynamic";

export const Disclaimer = dynamic(() => import("./Disclaimer"), {
  ssr: false
});
